/**
 * 银行审核接口的service
 */

import { post, get } from '@/request/http';
// eslint-disable-next-line import/no-extraneous-dependencies
import QS from 'qs';

const PublicPage = {
  // 获取订单信息
  getOrderList(params) {
    return post('/backloansuper/loan/supermarket/getOrderList', params);
  },
  // 获取聚合订单
  getAggsList() {
    return get('/backloansuper/loan/supermarket/getAggsOrderList');
  },
  // 获取聚合子订单
  getAggsSubOrderList(params) {
    return get(`/backloansuper/loan/supermarket/getAggsSubOrderList?aggsOrderId=${params.aggsOrderId}`);
  },
  getCreditSuccessInfo({ orderId, productId }) {
    return post(
      `/backloansuper/loan/supermarket/getCreditSuccessInfo?orderId=${orderId}&productId=${productId}`,
    );
  },
  hasFundAccount(params) {
    return post('/backloansuper/loan/supermarket/hasFundAccount/v1.0', params);
  },
  preJumpCurrPage(params) { // 翰华 是否可提额 {"flag":"0:不弹窗，1:翰华弹窗", "message":"弹窗话术"}
    return post('/backloansuper/loan/supermarket/preJumpCurrPage/v1.0', params);
  },
  jumpCurrPage(params) {
    return get('/backloansuper/loan/supermarket/jumpCurrPage/v1.0', params);
  },
  jumpRepayUrl(params) {
    return get('/backloansuper/loan/supermarket/jumpRepayUrl/v1.0', params);
  },
  download(params) {
    return post(`/backloansuper/loan/supermarket/download?url=${params.url}`, {
      xhrFields: { withCredentials: true },
      crossDomain: true,
    });
  },
  logout(params) {
    return post('/backloansuper/loan/supermarket/logout', params);
  },
  // 注销账户
  destroyAccount(params) {
    return post('/backloansuper/loan/supermarket/updateUserStatus/v1.0', {
      status: '0',
    });
  },
  getSms(params) {
    return post('/backloansuper/loan/supermarket/sms/v1.0', params);
  },
  getVerify(params) {
    return post('/backloansuper/loan/supermarket/getLoginVerify/v1.0', params);
  },
  login(params) {
    return post('/backloansuper/loan/supermarket/login/v1.0', QS.stringify(params), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
  },
  loginCaptcha(params) {
    return post('/backloansuper/loan/supermarket/loginCaptcha/v1.0', QS.stringify(params), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
  },
  getVerifySMS(params) {
    return post('/backloansuper/loan/supermarket/verifySMS/v1', params);
  },
  updatePassword(params) {
    return post('/backloansuper/loan/supermarket/updatePassword/v1.0', params);
  },
  register(params) {
    return post('/backloansuper/backloansuper/loan/supermarket/register', params);
  },

  addProtocol(params) {
    return get('/backloansuper/loan/supermarket/addProtocol', params);
  },

  getProtocolList(params) {
    return post('/backloansuper/loan/supermarket/getProtocolList', params);
  },
  getBankInfo(params) {
    return post('/backloansuper/loan/supermarket/getBankInfo', params);
  },
  uploadImg(params) {
    return post('/backloansuper/loan/supermarket/upload', params, {
      headers: {
        'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryWvnc4eK0wN9xwRGs',
      },
    });
  },
  getRepaymentPlan(params) {
    console.log(params);
    return post('/backloansuper/loan/supermarket/repayment/detail', QS.stringify(params), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
  },
  // 获取前端指引的链接
  getRepayGuide(params) {
    return post(`/backloansuper/loan/supermarket/product/getRepayGuide?orderId=${params.orderId ? params.orderId : ''}`, params);
  },
  // 判断还款详情页面按钮是否展示
  buttonController(params) {
    return post('/backloansuper/loan/supermarket/buttonController/v1.0', params, {
    });
  },
  // 跳转到还款试算页面
  repayJump(params) {
    return get(
      '/backloansuper/loan/supermarket/repayJump/v1.0',
      params,
    );
  },

  getPintecUrl(params) {
    return post('/backloansuper/loan/supermarket/dumiao/getPage', params);
  },
  // 获取所有的产品
  getproductList(params) {
    return get(
      `/backloansuper/loan/supermarket/productList?districtId=999999&seq=${1}&pageSize=${50}`,
      params,
    );
  },
  getProductDetail(params) {
    return post(
      `/backloansuper/loan/supermarket/product/products`,
      params,
    );
  },
  // 重新获取orderId
  getUnfinishedOrder(params) {
    return post('/backloansuper/loan/supermarket/getUnfinishedOrder/v3', QS.stringify(params), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
  },
  // 是否可申请产品
  hasApplyForProduct(params) {
    return get('/backloansuper/loan/supermarket/hasApplyForProduct', params);
  },
  // 获取最新的orderid
  getUserLastOrder(params) {
    return post(
      '/backloansuper/loan/supermarket/getUserLastOrder?code=default',
      QS.stringify(params),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    );
  },

  // 已经授信企业
  getBindingEnterprise(params) {
    return post('/backloansuper/loan/supermarket/getBindingCorpList/v1.0', params);
  },
  // 去重-已经授信企业
  getBindingEnterpriseUnique(params) {
    return post('/backloansuper/loan/supermarket/getBindingCorpList/v1.1', params);
  },
  // 获取用户信息
  getUserInfo(params) {
    return post('/backloansuper/loan/supermarket/getUserInfo/v1.0', params);
  },
  // 获取用户手机号
  getUserPhone(params) {
    return post('/backloansuper/loan/supermarket/getUserPhone/v1.0', params);
  },

  // 绑定新企业
  submitCertification(params) {
    return post('/backloansuper/loan/supermarket/bindCorpInfo/v1.0', params);
  },

  // 实名认证
  authentication(params) {
    return post('/backloansuper/loan/supermarket/userAuth/v1.0', params);
  },
  // 获取手机号码接口
  getLoginPhone(params) {
    return get('/backloansuper/loan/supermarket/getLoginPhone/v1.0', params);
  },
  // 获取产品配置
  getProductConfig(params) {
    return post('/backloansuper/loan/supermarket/product/config/v1.0', params);
  },
  // 验证码验证
  loginVerify(params) {
    return post('/backloansuper/loan/supermarket/loginVerify/v1.0', params);
  },
  // 获取手机验证码(登录状态)
  getSmsWithLogin(params) {
    if (params.method) {
      delete params.method;
    }
    return post('/backloansuper/loan/supermarket/smsWithLogin/v1.0', params);
  },
  // 搜索建议
  getSuggest(params) {
    return get(
      // `/backloansuper/search/v1/api/suggest`,
      '/backloansuper/search/v1/api',
      params,
    );
  },
  // 获取联合登录反显信息
  queryForeignOrderShow(params) {
    return post('/backloansuper/loan/supermarket/queryForeignOrderShow/v1.0', params);
  },
  // 获取企业信息
  getUserCorp(params) {
    return post('/backloansuper/loan/supermarket/getUserCorp/v1.0', params);
  },
  // 保存进件信息
  saveOrder(params) {
    return post('/backloansuper/loan/supermarket/saveOrder/v1.0', params);
  },
  getPerfectUrl(params) {
    return get('/backloansuper/loan/supermarket/perfectUrl/v1.0', params);
  },
  getPerfectOrderInfo(productId) {
    if (!productId) {
      return Promise.resolve({ returnMessage: '暂无订单信息' });
    }
    return post(
      '/backloansuper/loan/supermarket/getPerfectOrderInfo/v1.0',
      { productId },
      {
        'Content-Type': 'application/json',
      },
    );
  },
  // 查询产品协议
  queryContractInfo(params) {
    return post('/backloansuper/loan/supermarket/queryContractInfo/v1.0', params);
  },
  // 查询产品协议列表
  queryAllContract(params) {
    return post('/backloansuper/loan/supermarket/queryAllContract/v1.0', params);
  },
  // 下载PDF接口
  getDownloadContractUrl(params) {
    return get('/backloansuper/loan/supermarket/getDownloadContractUrl/v1.0', params);
  },
  // 通用下载PDF接口
  getDownloadUrl(params) {
    return get('/backloansuper/loan/supermarket/file/getDownloadUrl/v1.0', params);
  },
  // 获取二维码链接
  getScanCode(params) {
    return post('/backloansuper/loan/supermarket/productQrInfo/v1.0', params);
  },
  // 获取微信配置
  getWXConfig(params) {
    return post('/backloansuper/loan/supermarket/getTicketInfo/v2', params);
  },
  // 获取IP
  getIPConfig(params) {
    return get('https://www.taobao.com/help/getip.php');
  },
  // 获取产品对应的跳转地址
  getProductWXConfig(params) {
    return post('/backloansuper/loan/supermarket/getWxConf/v1.0', params);
  },
  // 授信额度变更
  getCreditUpdate(params) {
    return post('/backloansuper/loan/supermarket/creditUpdate/v1.0', params);
  },
  // 信息认证接口 (下一步)
  nextProductConfig(params) {
    return post('/backloansuper/loan/supermarket/infoAuth/v1.0', params);
    //  根据税号 和 产品id 获取最新的产品id
  },
  // 信息认证接口 (下一步)（联合登录）
  saveOrderUnite(params) {
    return post('/backloansuper/loan/supermarket/loginAndSaveOrder/v1.0', params);
    //  根据税号 和 产品id 获取最新的产品id
  },
  getNewProductId(params) {
    return post('/backloansuper/loan/supermarket/product/areaRoute', params);
  },
  // 校验发票
  checkAmount(params) {
    return post('/backloansuper/loan/supermarket/uploadInvoice', params);
  },
  // 获取该产品所属服务银行名称
  getBankNameByProduct(params) {
    return post('/backloansuper/loan/supermarket/product/legal/config/v1.0', params);
  },
  // 查询脱敏账户
  getHideAccount(params) {
    return post('/backloansuper/loan/supermarket/getHideAccount/v1.0', params);
  },
  // 查看卡号跳转的链接
  getSuccessfulLink(params) {
    return post('/backloansuper/loan/supermarket/getSuccessfulLink/v1.0', params);
  },
  // 查询是什么渠道
  getOrderType(params) {
    return post('/backloansuper/loan/supermarket/getOrderType/v1.0', params);
  },
  // 判断接口是否需要采集数据
  isDataAcquisition(params) {
    return post('/backloansuper/loan/supermarket/getPageAvailable/v1.0',
      params);
  },
  // 数据上传方式
  getCollectInterface(params) { // 数据采集入口 0 不开通 1 手机上传 2电脑上传 3双端上传
    return get('/backloansuper/loan/supermarket/product/getCollectInterface',
      params);
  },
  // 发票详情数据
  getInvoiceDetailList(params) {
    return post('/backloansuper/loan/supermarket/getThreeYearsReport/v1.0',
      params);
  },
  // 采集状态
  getCollectStatus(params) {
    return post('/backloansuper/loan/supermarket/getCollectStatus/v1.0',
      params);
  },
  // RPA跳转链接
  getRpaUrl(params) {
    return post('/backloansuper/loan/supermarket/getRpaUrl/v1.0',
      params);
  },
  // 提款页面获取申请期限
  getSpdbRepayTerm(params) {
    return post('/backloansuper/loan/supermarket/getSpdbRepayTerm/v1.0', params);
  },

  // 优企贷-提款页面获取申请期限
  getYQDSpdbRepayTerm(params) {
    return post('/backloansuper/loan/supermarket/yqd/getRepayTerm/v1.0', params);
  },
  // 在途订单判断
  hasOrderDoingByUserId(params) {
    return post('/backloansuper/loan/supermarket/hasOrderDoingByUserId', params);
  },
  verifySMSWithLogin(params) {
    return get('/backloansuper/loan/supermarket/verifySMSWithLogin', params);
  },

  // 修改手机号
  modifyPhone(params) {
    return post('/backloansuper/loan/supermarket/modifyPhone/v1.0', params);
  },
  // 修改企业名称
  updateCorpName(params) {
    return post('/backloansuper/loan/supermarket/modifyCorpName', params);
  },

};

export default PublicPage;
